import { Document } from '@rossum/api-client/documents';
import { SnakeCaseStatus } from '../../../../types/annotationStatus';

export type AttachedAnnotation = {
  id: number;
  url: string;
  status: SnakeCaseStatus;
  pages: string[];
  email: string | null;
  relatedEmails: string[];
  createdAt: string;
  restrictedAccess: boolean;
};

export type AttachmentT = {
  document: Document;
  annotation?: AttachedAnnotation;
  annotationModifier?: { id: number; username: string } | undefined;
};

export const isAnnotationDisabled = (status: SnakeCaseStatus) =>
  status === 'importing' || status === 'failed_import';
